export const FULL_CART_MIN_QUANTITY = 5;

const CURVE_RANKS = {
  A: 0,
  B: 1,
  C: 2,
};

const normalizeCurveValue = (value) => {
  const normalized = String(value || "")
    .trim()
    .toUpperCase()
    .replace(/^CURVA\s+/, "");

  return CURVE_RANKS[normalized] !== undefined ? normalized : null;
};

export const getFullCartCurveCode = (item) =>
  normalizeCurveValue(
    item?.curveTag ||
      item?.curve ||
      item?.product?.curveTag ||
      item?.product?.curve ||
      item?.data?.curveTag ||
      item?.data?.curve
  );

export const getFullCartCurveRank = (item) => {
  const curveCode = getFullCartCurveCode(item);
  return curveCode ? CURVE_RANKS[curveCode] : 99;
};

export const getFullCartEntryIdentity = (item) => {
  const rawIdentity =
    item?.id ??
    item?.meliProductId ??
    item?.idMeli ??
    item?.productId ??
    item?.product?.id ??
    item?.product?.sku ??
    item?.sku ??
    "";

  return String(rawIdentity || "").trim();
};

export const getFullCartDomKey = (item) =>
  encodeURIComponent(getFullCartEntryIdentity(item));

export const getFullCartMinimumQuantity = (item) => {
  const seasonalMinimum =
    item?.seasonalCartRules?.enforceMin === true
      ? Number(item?.seasonalCartRules?.minQuantity)
      : 0;

  return Math.max(
    FULL_CART_MIN_QUANTITY,
    Number.isFinite(seasonalMinimum) ? seasonalMinimum : 0
  );
};

export const normalizeFullCartQuantity = (item, value) => {
  const parsed = Number.parseInt(String(value ?? ""), 10);
  const safeValue = Number.isInteger(parsed) && parsed > 0 ? parsed : 0;
  return Math.max(getFullCartMinimumQuantity(item), safeValue);
};

export const compareFullCartEntries = (left, right) => {
  const curveDelta = getFullCartCurveRank(left) - getFullCartCurveRank(right);
  if (curveDelta) return curveDelta;

  const salesDelta = (Number(right?.totalSales) || 0) - (Number(left?.totalSales) || 0);
  if (salesDelta) return salesDelta;

  const leftSku = String(left?.product?.sku || left?.sku || "");
  const rightSku = String(right?.product?.sku || right?.sku || "");
  const skuDelta = leftSku.localeCompare(rightSku, "pt-BR", {
    numeric: true,
    sensitivity: "base",
  });
  if (skuDelta) return skuDelta;

  return getFullCartEntryIdentity(left).localeCompare(
    getFullCartEntryIdentity(right),
    "pt-BR",
    { numeric: true, sensitivity: "base" }
  );
};

export const sortFullCartEntries = (entries = []) =>
  [...(Array.isArray(entries) ? entries : [])].sort(compareFullCartEntries);

export const areFullCartOrdersEqual = (left = [], right = []) => {
  if (left.length !== right.length) return false;

  return left.every(
    (entry, index) =>
      getFullCartEntryIdentity(entry) === getFullCartEntryIdentity(right[index])
  );
};
